import ReactDOM from 'react-dom';
import React from 'react'
import { ChakraProvider } from "@chakra-ui/react";
import LogRocket from 'logrocket';
LogRocket.init('ywg4vg/test');
import './index.css';
import App from './App';
import theme from './theme'

ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
